import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiService } from '@shared/base';
import { DPNUser, GridFilterOperator, GridQuery, gridQueryToRequestQuery, GridRespose, User } from '@shared/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AdminUsersApiService extends BaseApiService {
  constructor(private http: HttpClient) {
    super();
  }

  public getList(params: GridQuery): Observable<GridRespose<User>> {
    const reqParams = gridQueryToRequestQuery(params);
    const { columnName, descending } = reqParams.sorts[0];
    if (columnName === 'fullName') {
      reqParams.sorts = [
        {
          columnName: 'lastName',
          descending
        },
        {
          columnName: 'firstName',
          descending
        }
      ];
    }
    if (params.searchText) {
      params.searchText
        .split(' ')
        .map(term => term.replace(/,/g, ''))
        .forEach(term => {
          reqParams.filters.push({
            columnNames: ['firstName', 'lastName', 'emailAddress'],
            operator: GridFilterOperator.Contains,
            values: [term]
          });
        });
    }
    return this.http
      .post<GridRespose<User>>(`${this.queryBaseUrl}/admin/users/query`, reqParams)
      .pipe(map(resp => ({ ...resp, items: resp.items.map(i => new User(i)) })));
  }

  public delete(id: string) {
    return this.http.delete<unknown>(`${this.commandBaseUrl}/admin/users/${id}`);
  }

  public add(data: DPNUser) {
    return this.http.post<unknown>(`${this.commandBaseUrl}/admin/users`, data);
  }

  public search(searchText: string, limit = 5): Observable<DPNUser[]> {
    return this.http
      .get<
        {
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          office: string;
          disabled: boolean;
        }[]
      >(`${this.queryBaseUrl}/admin/users/search`, {
        params: {
          keyword: searchText,
          take: limit.toString()
        },
        headers: {
          omitLoader: 'true'
        }
      })
      .pipe(map(data => data.map(u => new DPNUser({ ...u, emailAddress: u.email, userId: u.id }))));
  }
}
